import { InjectionToken } from '@angular/core';

export const DEFAULT_LANGUAGE = 'en';

export function getLanguageFromUrl(): string {
  const url = new URL(window.location.href);
  const query = url.searchParams.get('language')?.toLowerCase();
  return query ?? DEFAULT_LANGUAGE;
}

export const LANGUAGE = new InjectionToken<string>(
  'Showcase language from URL',
);
